import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "../../controllers/utilityController";

const getGreeting = (date) => {
  const hour = date.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

const formatToday = (date) =>
  date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

/**
 * Greeting, today's date and a row of quick-action shortcuts.
 * @param {{ subtitle?: string,
 *           actions?: { label: string, icon: React.ComponentType, to: string,
 *                       state?: object, primary?: boolean }[] }} props
 */
function DashboardHeader({ subtitle, actions = [] }) {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const today = new Date();

  useEffect(() => {
    getUserProfile()
      .then((res) => setName(res?.name || ""))
      .catch(() => setName(""));
  }, []);

  const firstName = name.trim().split(/\s+/)[0];

  return (
    <section className="flex flex-col gap-4 rounded-xl border border-app-primary bg-app-card p-5 shadow-sm lg:flex-row lg:items-center lg:justify-between">
      <div className="min-w-0">
        <p className="text-xs font-medium uppercase tracking-wide text-app-muted">
          {formatToday(today)}
        </p>
        <h2 className="mt-1 text-2xl font-semibold text-app-heading">
          {getGreeting(today)}
          {firstName ? `, ${firstName}` : ""}
        </h2>
        {subtitle && <p className="mt-1 text-sm text-app-muted">{subtitle}</p>}
      </div>

      {actions.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {actions.map(({ label, icon: Icon, to, state, primary }) => (
            <button
              key={label}
              type="button"
              onClick={() => navigate(to, state ? { state } : undefined)}
              className={
                "inline-flex h-10 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-3.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40 " +
                (primary
                  ? "bg-blue-600 text-white hover:bg-blue-700"
                  : "border border-app-primary bg-app-card text-app-secondary hover:bg-app-hover hover:text-app-primary")
              }
            >
              {Icon && <Icon size={16} strokeWidth={1.75} aria-hidden="true" />}
              {label}
            </button>
          ))}
        </div>
      )}
    </section>
  );
}

export default DashboardHeader;
